export default "__VITE_ASSET__Ci6RLB9b__"